import { apiBaseUrl } from "../../configs/app";
import { localStorageSafeSetItem } from "../cache.services";
import Category, { SubCategory } from "../../types/category.type";
import CryptoService from "../crypto.services";

const localStorageKey = CryptoService.hash('categories-and-subcategories')

export function localCategories() {
    try {
        const localData = window.localStorage.getItem(localStorageKey)
        return (localData ? JSON.parse(CryptoService.decrypt(localData)).categories : []) as Category[]
    } catch (e) {
        return [] as Category[]
    }
}
export function getCategory(categories:Category[],catID:number) {
    return categories ? categories.find((item, index) => (catID === item.id)) : undefined
}
export function getSubCategory(items:SubCategory[],subCatID:number) {
    return items ? items.find((item, index) => (subCatID === item.id)) : undefined
}

let inFlightCategoriesPromise: Promise<Category[]> | null = null;

export function fetchCategories(): Promise<Category[]> {
    if (inFlightCategoriesPromise) {
        return inFlightCategoriesPromise;
    }

    const requestOptions = {
        method: 'POST',
        cache: "no-store",
        redirect: 'follow'
    };
    const url = apiBaseUrl + 'products/categories-and-subcategories';

    inFlightCategoriesPromise = fetch(url, requestOptions as RequestInit)
        .then(async (res) => {
            if (!res.ok) {
                console.warn(`[Categories] API request returned status ${res.status}`);
                return localCategories();
            }
            const data = await res.json();
            if (data && data.success && Array.isArray(data.categories)) {
                localStorageSafeSetItem(localStorageKey, CryptoService.encrypt(JSON.stringify(data)));
                return data.categories as Category[];
            }
            return localCategories();
        })
        .catch((err) => {
            console.error("[Categories] Error fetching categories:", err);
            return localCategories();
        })
        .finally(() => {
            inFlightCategoriesPromise = null;
        });

    return inFlightCategoriesPromise;
}
